module.exports = "https://beta.voredev.ru/assets/index/green-check-mark-846655f10dd6761ed5d9a39bed7497c8.svg";